/*
 * Filename: podcast.js
 * By: J. Nguyen
 * Date: 9/7/21
 *
 * Description: 
 * This will house the podcase archive page logic.
 *
 */


import TabbedContent from '../modules/tabbed-content.js'; 

const defaults = {             
  debugMode: false
}

// DOM NODES
const tabbedContentNode = document.getElementsByClassName('tabbed-content')[0];


init();
 
// initilize the module
function init() {
  
  TabbedContent(tabbedContentNode, {
    noWrap: false
  });

}


// Basic debug function
function debug(msg) { 
  if (defaults.debugMode) {
    console.log(msg);
  }
}

